import type { ReactNode } from 'react';
import { Link, useNavigate } from 'react-router';
import { TrackframeHeader } from '@verybigthings/trackframe-hub-client/ui/components/header';
import { hubBaseUrl } from '@/lib/hub-client';

// Chrome for the hub root page (track list). Same shared header as the admin
// shell and every track frontend, but without the admin sidebar. M28 (ADM-11):
// the user-facing nav lives in the avatar menu — the CONN-08 Integrations link
// that used to sit in the center slot would be a second entry to the same
// screen, so the slot is left empty (the stories render that state too).
export function HubLayout({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  return (
    <div className="flex h-screen w-screen flex-col overflow-hidden bg-background text-foreground">
      <TrackframeHeader
        hubBaseUrl={hubBaseUrl}
        onLogoClick={() => navigate('/')}
        userMenuItems={
          <>
            <Link to="/me/documents" className="tf-header-menu-item">
              My documents
            </Link>
            <Link to="/me/integrations" className="tf-header-menu-item">
              Integrations
            </Link>
            <Link to="/admin/schedules" className="tf-header-menu-item">
              Scheduled actions
            </Link>
            <Link to="/me/account" className="tf-header-menu-item">
              Account
            </Link>
          </>
        }
      />
      <main className="flex-1 overflow-y-auto">{children}</main>
    </div>
  );
}
